import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  if (import.meta.env.DEV) {
    console.info("Supabase credentials missing — mode localStorage (fallback)");
  }
}

export const supabase =
  supabaseUrl && supabaseAnonKey ? createClient(supabaseUrl, supabaseAnonKey) : null;

export function isSupabaseConfigured() {
  return !!supabase;
}

/** Coach connecté (UUID) — prêt pour écritures RLS */
export function isSupabaseReady(coachId) {
  return isSupabaseConfigured() && !!coachId && coachId !== "local-coach";
}
